import React from "react";
import { TableBody } from "@material-ui/core";

export const DataBody = ({ children, classes, ...props }) => {
	return <TableBody {...props}>{children}</TableBody>;
};
export default DataBody;
